import { api } from "./client";
import type { Subscription, SubscriptionCreateRequest } from "../../types/usage";

export async function listSubscriptions(): Promise<Subscription[]> {
  const response = await api.get("/admin/subscriptions");
  return response.data;
}

export async function createSubscription(data: SubscriptionCreateRequest): Promise<Subscription> {
  const response = await api.post("/admin/subscriptions", data);
  return response.data;
}

export async function cancelSubscription(subscriptionId: string): Promise<void> {
  await api.delete(`/admin/subscriptions/${subscriptionId}`);
}
